import React, { createContext, ReactNode, useContext, useState } from 'react';

import { TranslationKeys } from '../i18n/locales/defaultResources';

export interface TranslationContextType {
  isTranslationMode: boolean;
  setActiveKey: (key: TranslationKeys) => void;
  activeKey: TranslationKeys;
  toggleTranslationMode: () => void;
  translationVersion?: boolean;
}

const TranslationContext = createContext<TranslationContextType | undefined>(
  undefined
);

export const TranslationProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isTranslationMode, setTranslationMode] = useState(false);
  const [activeKey, setActiveKey] = useState<TranslationKeys>(
    TranslationKeys.empty
  );

  const toggleTranslationMode = () => {
    setTranslationMode(!isTranslationMode);
  };

  return (
    <TranslationContext.Provider
      value={{
        isTranslationMode,
        setActiveKey,
        activeKey,
        toggleTranslationMode,
      }}
    >
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslationContext = () => {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error(
      'useTranslationContext must be used within a TranslationProvider'
    );
  }
  return context;
};
